/**
 * Setup react-bootstrap
 *
 * - Make sure Portal, Modal etc. are by default rendered inside .rlbs container
 */
/* eslint-disable import/no-extraneous-dependencies */
import Overlay from "react-bootstrap/Overlay";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Modal from "react-bootstrap/Modal";

const { document } = global;
const div = document.createElement("div");
div.setAttribute("class", "rlbs");

document.addEventListener("DOMContentLoaded", () =>
  document.body.insertBefore(div, document.body.firstChild)
);

Overlay.defaultProps = Object.assign({}, Overlay.defaultProps || {}, {
  container: div
});

OverlayTrigger.defaultProps = Object.assign(
  {},
  OverlayTrigger.defaultProps || {},
  {
    container: div
  }
);

Tooltip.defaultProps = Object.assign({}, Tooltip.defaultProps || {}, {
  container: div
});

Modal.defaultProps = Object.assign({}, Modal.defaultProps || {}, {
  container: div
});
